<template>
  <div class="footerCon">
    <div class="content">
      <div class="top">
        <div class="left"></div>
        <div class="right" v-if="false">
          <span @click="linkShowFunc">
            友情链接
            <el-icon class="ml6" v-show="!linkShow">
              <ArrowDown />
            </el-icon>
            <el-icon class="ml6" v-show="linkShow">
              <ArrowUp />
            </el-icon>
          </span>
          <span></span>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <img src="@/assets/sydw.png" @click="goSYDW" class="cursor" v-if="false"/>
          <img src="@/assets/yy.png" v-if="false" />
        </div>
        <div class="line"></div>
        <div class="middle">
          <P class="mb16"
            ><span @click="goBEIAN" class="cursor blue"
              >蜀ICP备2025125753号-2</span
            >
            四川一诚天和科技有限公司 版权所有</P
          >
          <P class="mb16"
            >郑重声明：四川一诚天和科技有限公司官方网站为<span
              class="cursor blue"
              @click="backToHome"
              >www.scycth.com</span
            >，如有仿照将依法追究其法律责任</P
          >
          <P class="mb16"
            >本站信息仅供参考，如有转载或引用本站文章涉及版权问题，请速与我们联系</P
          >
        </div>
        <div class="line"></div>
        <div class="right">
          <P class="mb16">联系我们：18215564998</P>
          <P class="mb16" @click="backToHome"
            >网址：<span class="cursor blue">www.scycth.com</span></P
          >
          <P class="mb16"
            >地址：高新区孵化园&nbsp;&nbsp;&nbsp;&nbsp;邮编：610000</P
          >
        </div>
      </div>
    </div>
    <!-- 友情链接内容 -->
    <div class="link_con" v-show="linkShow">
      <div class="link_content">
        <div
          class="link_item"
          v-for="link in links"
          :key="link.name"
          @click="goOther(link)"
        >
          {{ link.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ArrowDown, ArrowUp } from "@element-plus/icons-vue";
import { ref } from "vue";
const backToHome = () => {};
const links = [
  { name: "中华人民共和国国家卫健康生委员会", link: "http://www.nhc.gov.cn/" },
  { name: "四川省人民政府", link: "http://www.sc.gov.cn/" },
  { name: "四川省卫生健康委员会", link: "https://wsjkw.sc.gov.cn/" },
  { name: "凉山彝族自治州卫生健康委员会", link: "https://wjw.lsz.gov.cn/" },
  { name: "北京协和医院", link: "http://www.pumch.cn/Index.html" },
  { name: "北京中日友好医院", link: "http://www.zryhyy.com.cn/" },
  { name: "四川大学华西医院", link: "https://www.wchscu.cn/index.html" },
  { name: "四川省人民医院", link: "http://www.samsph.com/" },
  { name: "重庆医科大学", link: "http://www.cqmu.edu.cn/" },
  { name: "泸州医学院", link: "http://www.swmu.edu.cn/" },
  { name: "中华医学会", link: "http://www.cma.org.cn/" },
  { name: "四川省医学会", link: "http://www.sma.org.cn/" },
  { name: "四川省住院医师规范化培训网", link: "http://zyyspx.scyxkj.org.cn/" },
];
const linkShow = ref(false);
const linkShowFunc = () => {
  linkShow.value = !linkShow.value;
};
const goOther = (link) => {
  console.log(link.link);
  window.open(link.link);
};
const goSYDW = () => {
  goOther({
    link: "https://bszs.conac.cn/sitename?method=show&id=F636E3D4CCE7334BE05310291AAC5F26",
  });
};
const goBEIAN = () => {
  goOther({ link: "https://beian.miit.gov.cn/" });
};
</script>
<style scoped lang="less">
@import "@/styles/global.less";
.footerCon {
  width: 100%;
  background-color: #333e50;
  position: relative;

  .content {
    width: @width;
    margin: 0 auto;
    font-size: 12px;

    .top {
      color: #cccccc;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      padding: 12px 0px;
      border-bottom: 1px solid #525a66;

      .left {
        display: flex;
        gap: 12px;
      }

      .right {
        color: #14b5ae;
        display: flex;
        gap: 12px;

        span {
          cursor: pointer;
        }
      }
    }

    .bottom {
      padding: 24px 0px;
      display: flex;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
        gap: 24px;
        padding-right: 24px;
        img {
          width: 55px;
        }
      }

      .line {
        width: 0px;
        border-right: 1px solid #525a66;
      }

      .middle {
        color: #cccccc;
        padding: 0 24px;
      }

      .right {
        color: #cccccc;
        padding-left: 24px;
      }
    }
  }

  .link_con {
    width: 100%;
    background-color: #2c2c2c;
    text-align: center;
    position: absolute;
    top: 40px;
    left: 0px;
    font-size: 14px;

    .link_content {
      width: @width;
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      margin: 0 auto;
      padding: 20px 0px;

      .link_item {
        color: #999999;
        cursor: pointer;
      }
    }
  }
}
.cursor {
  cursor: pointer;
}
.blue {
  color: #2385c9;
}
</style>
